import React from "react";
import MGATable from "./MGATable";

const MGA = () => {
  return (
    <div>
      <MGATable />
    </div>
  );
};

export default MGA;
